var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'providers' }}},[_vm._v("Providers")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'create_provider' }}},[_vm._v("New Provider")])],1),_vm._v(" "),(_vm.providerId)?_c('li',[_c('router-link',{attrs:{"to":{
          name: 'edit_provider',
          params: {
            providerId: _vm.providerId
          }
        }}},[_vm._v("\n        Edit Provider\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.providerId)?_c('li',[_c('router-link',{attrs:{"to":{
          name: 'provider_puzzles',
          params: {
            providerId: _vm.providerId
          }
        }}},[_vm._v("\n        Puzzles\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf691722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProviderNav.vue
// module id = 1278
// module chunks = 1